import * as React from 'react';
import { Link } from 'react-router-dom';

import { BackIcon } from '@/components/pulse/icons';

export type ProjectView = 'overview' | 'board' | 'milestones' | 'meetings' | 'domains' | 'acceptance';

/**
 * A project's tab row (PRJ-1), the prototype's `projectTabs()`: an All projects link back to the
 * list, then Overview, Board, Milestones, Meetings, Domains and Acceptance. No tabs for other
 * projects. Board needs a board; Domains and Acceptance need a story repository.
 */
export function ProjectTabs({
  slug,
  hasBoard,
  hasStories,
  view,
}: {
  readonly slug: string;
  readonly hasBoard: boolean;
  readonly hasStories: boolean;
  readonly view: ProjectView;
}): React.ReactElement {
  const tab = (key: ProjectView, label: string, enabled: boolean, why: string) =>
    enabled ? (
      <Link key={key} className="tab" to={key === 'overview' ? `/projects/${slug}` : `/projects/${slug}/${key}`} aria-current={view === key ? 'page' : undefined}>
        {label}
      </Link>
    ) : (
      <span key={key} className="tab" title={why} style={{ cursor: 'default', opacity: 0.55 }}>
        {label}
      </span>
    );
  return (
    <>
      <Link className="linkish" to="/projects" style={{ alignSelf: 'flex-start' }}>
        <BackIcon /> All projects
      </Link>
      <div className="tabsbar">
        <nav className="tabs" aria-label="View">
          {tab('overview', 'Overview', true, '')}
          {tab('board', 'Board', hasBoard, 'This project has no board')}
          {tab('milestones', 'Milestones', true, '')}
          {tab('meetings', 'Meetings', true, '')}
          {tab('domains', 'Domains', hasStories, 'No story repository for this project')}
          {tab('acceptance', 'Acceptance', hasStories, 'No story repository for this project')}
        </nav>
      </div>
    </>
  );
}
